// extracted by mini-css-extract-plugin
export var bold = "_yn-0";